import _ from 'lodash';
import getParams from 'library-@/utils/get-params.js';
import { fixZpreface } from 'library-@/startup/index.js';
import { setRootRedirect } from '@/router/index.js';
import setTitle from '@/utils/setTitle.js';
import hideHeaderHandler from '@/utils/hideHeaderHandler.js';
import { initialize } from './initialize';
import { initializeLabApp } from './initialize-lab-app';
import { initializeDualViewSetting } from './initialize-dual-view-setting';
import type { Permission } from '@/domains/permission/types';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PermissionService } from '@/domains/permission/services/permission-service';

function syncPermissionsToHeaderStore(permissions: Partial<Permission>) {
    window.$bridge.store.batchWrite(['permissions'], (draft) => {
        draft.permissions = permissions;
    });
}

export async function startup(isFamilySearch: boolean) {
    const permissionService = injectService<PermissionService>(PermissionService);

    // 如果是inno跳转过来的 需要隐藏header 并且覆盖网站语言
    const { website_locale: websiteLocale } = getParams();

    const results = await initialize({ beforeInit: hideHeaderHandler, forceSetLocale: websiteLocale });
    if (!results) throw new Error('initialize failed');
    const {
        viewInitData: moduleConfig,
        globalConfig,
        locale,
        headerService,
        legalConfig,
        isFreeView,
    } = results;

    const isSpecialIp = _.get(globalConfig, 'userInfo.isSpecialIp', false);
    const zPREFACE = {
        NAME: 'patent-view',
        globalConfig,
        accountInfo: _.get(headerService, 'account._info', {}),
        legalConfig,
        pageConfig: {
            whiteLabel: headerService.whiteLabel,
        },
        moduleConfig,
        tplLinks: moduleConfig.tplLinks,
        usedAnchorInLab: {},
    };

    const serviceArea = _.get(zPREFACE, 'accountInfo.site_region', 'CN').toLowerCase();
    window.$bridge.store.write('helpCenterGuiderConfig', {
        module: 'patentView',
        serviceArea,
    });

    if (isFreeView) {
        window.$bridge.store.write('headerConfig.inputType', 'noInput');
    } else {
        // 获取lab功能是否开启
        zPREFACE.usedAnchorInLab = await initializeLabApp(_.get(headerService, 'account._info.site_region', ''));
    }

    window.zPREFACE = zPREFACE;
    /* 兼容遗留代码 */
    fixZpreface(locale);

    // 初始化路由重定向逻辑
    setRootRedirect(isFamilySearch);

    // init dual-view setting
    await initializeDualViewSetting(!isFreeView && !isSpecialIp);

    // 创建国际化相关内容
    setTitle({ locale, isWhiteLabel: headerService.whiteLabel });

    // 更新权限数据
    if (!_.isEmpty(moduleConfig.permissions)) {
        permissionService.updatePermission(moduleConfig.permissions as Permission);
        syncPermissionsToHeaderStore(moduleConfig.permissions as Permission);
    }

    return {
        locale,
    };
}
